export default __webpack_public_path__ + "static/Gas_Collector-87aeb3552a6dc63e3cc8d392b524ddc8.png";